import { createIcon } from "@chakra-ui/react";

export const BookLined = createIcon({
  displayName: "BookLined",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 3.897v14.886c1.377-.525 3.16-1.038 4.931-1.217 1.64-.165 3.417-.056 4.819.739V3.686c-.98-1.033-2.673-1.329-4.668-1.127-1.851.186-3.755.784-5.082 1.338zm11.25-.21v14.618c1.402-.795 3.179-.904 4.819-.739 1.77.179 3.554.692 4.931 1.217V3.897c-1.328-.554-3.23-1.152-5.081-1.338-1.996-.202-3.689.094-4.669 1.127zM12 2.33C10.523 1.06 8.38.87 6.431 1.066 4.16 1.296 1.867 2.075.44 2.723a.75.75 0 0 0-.44.683v16.5a.75.75 0 0 0 1.06.683c1.323-.601 3.455-1.322 5.522-1.53 2.111-.213 3.884.13 4.832 1.316a.75.75 0 0 0 1.172 0c.948-1.186 2.72-1.53 4.833-1.316 2.066.208 4.198.929 5.52 1.53A.75.75 0 0 0 24 19.906v-16.5a.75.75 0 0 0-.44-.683c-1.427-.648-3.72-1.428-5.991-1.657C15.619.87 13.477 1.061 12 2.331z"
    />,
  ],
  defaultProps: {
    "aria-label": "An open two-page spread of a book "
  }
});

export default BookLined;
